module.exports = __webpack_public_path__ + "2da5d6f98c9f5984b56de1319006a1db.svg";